module.exports = "/*\n * Namespace DTCR - \"DataTables ColReorder\" plug-in\n */\n\ntable.DTCR_clonedTable {\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 202;\n}\n\ndiv.DTCR_pointer {\n    width: 1px;\n    background-color: #0259C4;\n    z-index: 201;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/js/plugins/datatables/extensions/ColReorder/css/dataTables.colReorder.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/js/plugins/datatables/extensions/ColReorder/css/dataTables.colReorder.css
// module chunks = styles